<template>
  <div class="home_layout">
    <div class="home_body">
      <div class="data-list" v-if="dataList.length > 0">
        <div v-for="item in dataList" :key="item.orderDetailId" class="coupon-item">
          <div class="coupon-content" @click="detailClick(item)">
            <div class="left">
              <img class="pic" :src="getImageUrl(item.picUrl)"/>
              <div class="coupon-info">
                <div class="coupon-title">{{ item.goodsName }}</div>
                <div>
                  <div class="coupon-validate">领取日期{{ item.cardStartTime }}</div>
                  <div class="coupon-validate">有效期至{{ item.cardExpirationTime }}</div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="coupon-amount">
                <div class="amount">
                  <span>{{ item.amount }}</span>
                  元
                </div>
              </div>
              <!-- 修改1：添加已激活状态的判断，加入disabled-btn类 -->
              <div class="btn"
                   :class="{
                     'expired-btn': !item.enabledStatus || item.disabled ||
                                   (['4', '5', '6'].indexOf(item.useStatus) !== -1 && !item.isClickable) ||
                                   (item.goodsId === '5' && item.cardUseStatus === '1')// 新增：已激活状态禁用

                   }"
                   @click.stop="handleBtnClick(item)">
                {{ getBtnText(item) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="home_body_middle_nodata">
        <img
            src="../../../static/images/vip_discounts/nodata.png"
            alt=""
            width="100%"
            class="home_body_middle_nodata_img"/>
        <p class="home_body_middle_nodata_title">暂无优惠券</p>
        <p class="home_body_middle_nodata_content">您还没有领取优惠券喔～</p>
      </div>
    </div>

    <!-- 充值确认弹窗 -->
    <div v-if="showRechargeConfirm" class="recharge-modal">
      <div class="recharge-modal-mask"></div>
      <div class="recharge-modal-content">
        <div class="recharge-modal-header">
          <h3>充值确认</h3>
          <span class="recharge-modal-close" @click="closeRechargeConfirm">×</span>
        </div>
        <div class="recharge-modal-body">
          <p class="recharge-confirm-text">
            您确定要充值 <span class="recharge-amount">{{ currentRechargeItem && currentRechargeItem.amount }}</span>
            元吗？
          </p>
          <div class="recharge-info" v-if="currentRechargeItem">
            <p><span>商品名称：</span>{{ currentRechargeItem.goodsName }}</p>
            <p><span>充值金额：</span>{{ currentRechargeItem.amount }}元</p>
            <p><span>到账账户：</span><span class="recharge-account">{{ rechargeAccountText }}</span></p>
          </div>
        </div>
        <div class="recharge-modal-footer">
          <button class="recharge-btn-cancel" @click="closeRechargeConfirm">取消</button>
          <button class="recharge-btn-confirm" @click="confirmRecharge">确认充值</button>
        </div>
      </div>
    </div>

    <!-- 充值结果弹窗 -->
    <div v-if="showRechargeResult" class="recharge-modal">
      <div class="recharge-modal-mask"></div>
      <div class="recharge-modal-content">
        <div class="recharge-modal-header">
          <h3>{{ rechargeResult.title }}</h3>
        </div>
        <div class="recharge-modal-body result-body">
          <div class="result-icon" :class="rechargeResult.iconClass">
            <i :class="rechargeResult.icon"></i>
          </div>
          <p class="result-message">{{ rechargeResult.message }}</p>
        </div>
        <div class="recharge-modal-footer">
          <button class="recharge-btn-confirm" @click="closeRechargeResult">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {handleRequestError} from '@/static/js/common'

export default {
  data() {
    return {
      dataList: [],
      couponInfo: {},

      // 充值相关数据
      showRechargeConfirm: false,
      showRechargeResult: false,
      currentRechargeItem: null,
      // 商品维护的绑定账号（用于充值弹窗展示到账账户）
      bindAccount: '',
      accountLoading: false,
      rechargeResult: {
        success: false,
        title: '',
        message: '',
        icon: '',
        iconClass: ''
      }
    }
  },
  mounted() {
    const id = this.$route.params.orderId
    const couponId = this.$route.params.couponId
    const memberId = this.$route.params.memberId
    const goodsId = this.$route.params.goodsId
    this.couponInfo = {
      couponId,
      memberId,
      goodsId
    }
    this.getRecords(id)
  },
  computed: {
    ...mapState(['loginInfo']),
    // 是否山东区域（regionNo = 37）
    isShandongRegion() {
      const regionNo = this.$route.params.regionNo || localStorage.getItem('regionNo')
      return String(regionNo) === '37'
    },
    // 当前充值商品名称
    rechargeGoodsName() {
      return (this.currentRechargeItem && this.currentRechargeItem.goodsName) || ''
    },
    // 到账账户是否使用维护的绑定账号：
    // 非山东区域全部使用；山东区域仅天猫/淘宝类券使用，其他商品使用登录手机号
    isUseBindAccount() {
      if (!this.isShandongRegion) return true
      const goodsName = this.rechargeGoodsName
      return goodsName.includes('天猫') || goodsName.includes('淘宝')
    },
    // 充值到账账户
    rechargeAccountText() {
      if (!this.isUseBindAccount) {
        return this.loginInfo.mobile || this.loginInfo.phone || this.loginInfo.account || '--'
      }
      if (this.accountLoading) return '查询中...'
      return this.bindAccount || '未绑定账号'
    }
  },
  filters: {},
  methods: {
    /** 获取列表 */
    getRecords(id) {
      if (id !== undefined && id !== null && id !== '') {
        console.info('设置订单 id:', id);
        localStorage.setItem('orderId', id);
      } else {
        id = localStorage.getItem('orderId');
      }
      console.log('orderId', id)
      this.get(this.apis.findCardorderDetailList + '?orderId=' + id)
          .then((res) => {
            if (res.data.code === '0') {
              let data = res.data.data
              // 处理数据，添加充值相关字段
              this.dataList = data.map(item => {
                // 假设后端在item中返回了useStatus字段，如果没有则根据其他字段判断
                // 这里可以根据goodsName或其他字段判断是否是充值类型商品
                const isRechargeItem = this.isRechargeGoods(item.goodsName)
                const useStatus = item.useStatus || (isRechargeItem ? '3' : '0')

// 已激活判断
                const isActivated = item.goodsId === '5' && item.cardUseStatus === '1'

                return {
                  ...item,
                  useStatus: useStatus.toString(),
                  isClickable: !['4', '5', '6'].includes(useStatus.toString()) && !isActivated,
                  disabled: isActivated
                }
              })
              console.log('处理后的数据:', this.dataList)
            }
          })
          .catch((error) => {
            console.log(error)
            handleRequestError(this, error)
          })
    },

    /** 判断是否是充值商品 */
    isRechargeGoods(goodsName) {
      if (!goodsName) return false
      const rechargeKeywords = ['充值', '话费', '流量', '电费', '水费', '燃气']
      console.log('判断商品是否是充值商品：', goodsName)
      return rechargeKeywords.some(keyword => goodsName.includes(keyword))
    },

    getImageUrl(filename) {
      if (!filename || filename === 'null' || filename === 'undefined') {
        return require('@/static/images/vip_discounts/banner/jdtm_A.png');
      }
      return require(`@/static/images/vip_discounts/${filename}`);
    },

    /** 获取按钮文本 */
    getBtnText(item) {
      // 首先处理未生效状态
      if (!item.enabledStatus) {
        return '未生效'
      }

      // 如果有useStatus字段，优先根据它显示
      if (item.useStatus) {
        let statusMap = {
          '0': '立即使用',
          '1': '查看',
          '2': '下月使用',
          '3': '充值',
          '4': '充值成功',
          '5': '充值失败',
          '6': '充值中'
        }
        if (item.goodsId==='5'){
          statusMap = {
            '0': '激活',
            '1': '已激活'
          }
        }

        const statusText = statusMap[item.useStatus]
        if (statusText) {
          return statusText
        }
      }

      // 如果没有useStatus或不在状态映射中，使用原有逻辑
      return this.showEnabledStatus(item.enabledStatus, item.cardUseStatus, item.goodsId)
    },

    /** 原有的显示状态方法 */
    showEnabledStatus(status, cardStatus, goodsId) {
      console.log('123route', this.$route.params.regionNo)
      let regionNo = this.$route.params.regionNo || localStorage.getItem('regionNo');

      if (regionNo === '37') {
        if (!status) {
          return '未生效'
        }
        if (goodsId === '5') {
          if (status && cardStatus === '0') {
            return '激活'
          } else {
            return '已激活'
          }
        } else {
          if (status && cardStatus === '0') {
            return '立即使用'
          } else {
            return '查看'
          }
        }

      } else {
        if (!status) {
          return '未生效'
        }
        if (status && cardStatus === '0') {
          return '立即使用'
        } else {
          return '查看'
        }
      }
    },

    /** 按钮点击处理 */
    handleBtnClick(item) {
      console.log('按钮点击，状态:', item.useStatus, '生效状态:', item.enabledStatus)

      // 修改3：新增已激活状态的判断，直接返回不处理点击
      // 已激活状态不可点击
      if (item.goodsId === '5' && item.cardUseStatus === '1') {
        console.log('已激活状态，禁止点击')
        return
      }

      // 未生效的不可点击
      if (!item.enabledStatus) {
        return
      }

      // 充值成功、失败、充值中的不可点击
      if (['4', '5', '6'].includes(item.useStatus)) {
        return
      }

      // 根据useStatus处理点击
      switch (item.useStatus) {
        case '0': // 立即使用
        case '1': // 查看
          this.detailClick(item)
          break
        case '3': // 充值
          this.handleRechargeClick(item)
          break
        default:
          // 使用原有逻辑
          this.detailClick(item)
      }
    },

    /** 处理充值点击 */
    handleRechargeClick(item) {
      console.log('开始充值:', item)
      this.currentRechargeItem = item
      this.showRechargeConfirm = true
      // 到账账户为维护的绑定账号时（非山东区域全部、山东区域的天猫超市电子券），需要先查询回显
      if (this.isUseBindAccount) {
        this.queryBindAccount(this.getBindGoodsName(item))
      }
    },

    /** 获取用于查询绑定账号的商品名称（天猫/淘宝类券统一按天猫超市电子券查询） */
    getBindGoodsName(item) {
      const goodsName = (item && (item.goodsName || item.title)) || ''
      // 与详情页维护账号时使用的商品名保持一致，避免名称后缀不同导致查不到账号
      if (goodsName.includes('天猫') || goodsName.includes('淘宝')) return '天猫超市电子券'
      return goodsName
    },

    /** 查询维护的绑定账号（用于展示到账账户） */
    queryBindAccount(goodsName) {
      if (!this.loginInfo.id) {
        console.warn('用户未登录，无法查询绑定账号')
        return
      }
      this.accountLoading = true
      this.bindAccount = ''
      const params = {
        memberId: this.loginInfo.id,
        goodsName: goodsName
      }
      console.log('查询绑定账号参数：', params)
      this.post(this.apis.queryAccount, params)
          .then((res) => {
            this.accountLoading = false
            if (res.data.code === '0') {
              this.bindAccount = (res.data.data && res.data.data.account) || ''
              console.log('查询绑定账号成功（到账账户）：', this.bindAccount, goodsName)
            } else {
              console.log('查询绑定账号失败：', res.data.message)
            }
          })
          .catch((error) => {
            this.accountLoading = false
            console.log('查询绑定账号异常：', error)
          })
    },

    /** 确认充值 */
    async confirmRecharge() {
      // 先保存当前充值项目，避免异步操作中引用丢失
      const rechargeItem = this.currentRechargeItem
      if (!rechargeItem) {
        this.closeRechargeConfirm()
        return
      }

      try {
        // 关闭确认弹窗
        this.closeRechargeConfirm()

        // 找到要更新的项目
        const itemIndex = this.dataList.findIndex(item =>
            item.orderDetailId === rechargeItem.orderDetailId
        )

        if (itemIndex !== -1) {
          // 更新状态为充值中
          this.$set(this.dataList[itemIndex], 'useStatus', '6')
          this.$set(this.dataList[itemIndex], 'isClickable', false)
          this.$set(this.dataList[itemIndex], 'disabled', true)
        }

        // 获取区域编号
        const regionNo = this.$route.params.regionNo || localStorage.getItem('regionNo')

        console.log('充值参数:', {
          goodsName: rechargeItem.goodsName,
          regionNo: regionNo,
          orderId: rechargeItem.orderId,
          orderDetailId: rechargeItem.orderDetailId,
          couponId: this.couponInfo.couponId,
          memberId: this.couponInfo.memberId,
          goodsId: rechargeItem.goodsId
        })

        // 调用充值接口
        const response = await this.post(this.apis.recharge, {
          goodsName: rechargeItem.goodsName,
          regionNo: regionNo,
          orderId: rechargeItem.orderId,
          orderDetailId: rechargeItem.orderDetailId,
          couponId: this.couponInfo.couponId,
          memberId: this.couponInfo.memberId,
          goodsId: rechargeItem.goodsId,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        console.log('充值响应:', response)

        if (response.data.code === "200") {
          // 充值成功
          if (itemIndex !== -1) {
            this.$set(this.dataList[itemIndex], 'useStatus', '6')
          }

          // 显示成功提示
          this.showRechargeResult = true
          this.rechargeResult = {
            success: true,
            title: '充值提交成功',
            message: `充值${rechargeItem.amount}元订单已经提交成功，请注意查收！`,
            icon: 'el-icon-success',
            iconClass: 'success'
          }

          // 可以更新优惠券列表
          setTimeout(() => {
            this.getRecords(rechargeItem.orderId)
          }, 2000)

        } else {
          // 充值失败
          if (itemIndex !== -1) {
            this.$set(this.dataList[itemIndex], 'useStatus', '5')
          }

          // 显示失败提示
          this.showRechargeResult = true
          this.rechargeResult = {
            success: false,
            title: '充值失败',
            message: response.data.message || '充值失败，请重试',
            icon: 'el-icon-error',
            iconClass: 'error'
          }
        }

      } catch (error) {
        console.error('充值失败:', error)

        // 恢复状态 - 使用保存的rechargeItem
        const itemIndex = this.dataList.findIndex(item =>
            item.orderDetailId === rechargeItem.orderDetailId
        )

        if (itemIndex !== -1) {
          this.$set(this.dataList[itemIndex], 'useStatus', '3')
          this.$set(this.dataList[itemIndex], 'isClickable', true)
          this.$set(this.dataList[itemIndex], 'disabled', false)
        }

        // 显示错误提示
        this.showRechargeResult = true
        this.rechargeResult = {
          success: false,
          title: '充值失败',
          message: '网络错误，请稍后重试',
          icon: 'el-icon-error',
          iconClass: 'error'
        }
      }
    },

    /** 关闭充值确认弹窗 */
    closeRechargeConfirm() {
      // 只隐藏弹窗，不清除currentRechargeItem
      this.showRechargeConfirm = false
      // 这里不设置currentRechargeItem为null，让异步操作完成
    },

    /** 关闭充值结果弹窗 */
    closeRechargeResult() {
      this.showRechargeResult = false
      this.rechargeResult = {
        success: false,
        title: '',
        message: '',
        icon: '',
        iconClass: ''
      }
      // 在充值结果弹窗关闭时，才清除currentRechargeItem
      this.currentRechargeItem = null
    },

    showTime(item) {
      if (item.enabledStatus) {
        return item.cardStartTime + ' - ' + item.cardExpirationTime
      } else {
        return '生效时间：第一张使用后7天'
      }
    },

    /** 查看详情 */
    detailClick(item) {
      console.log('查看详情:', item)

      // 充值相关的状态不跳转详情页
      if (['3', '4', '5', '6'].includes(item.useStatus)) {
        console.log('充值状态，不跳转详情页')
        return
      }

      // 修改4：已激活状态不执行详情跳转逻辑
      if (item.goodsId === '5' && item.cardUseStatus === '1') {
        console.log('已激活状态，不跳转详情页')
        return
      }

      if (item.enabledStatus) {
        if (item.goodsId === '5') {
          if (item.cardUseStatus === '1') {
            return;
          }
          this.exchangeCode(item)
        } else {
          this.$router.push({
            name: 'couponDetail',
            params: {
              goodsName: item.goodsName,
              regionNo: this.$route.params.regionNo,
              orderId: item.orderId,
              orderDetailId: item.orderDetailId,
              couponId: this.couponInfo.couponId,
              memberId: this.couponInfo.memberId,
              seeFlag: item.cardUseStatus != '0' ? '2' : '1',
              goodsId: this.couponInfo.goodsId,
              cardgoodsId: item.id
            }
          })

          if (item.goodsName) {
            console.log('存入goodsName' + item.goodsName)
            localStorage.setItem('goodsName', item.goodsName)
          }

          if (item.orderDetailId) {
            console.log('存入orderDetailId' + item.orderDetailId)
            localStorage.setItem('goodsOrderDetailId', item.orderDetailId)
          }

          if (item.cardgoodsId) {
            console.log('存入cardgoodsId' + item.cardgoodsId)
            localStorage.setItem('CardGoodsId', item.cardgoodsId)
          }
        }
      }
    },

    /** 激活 */
    exchangeCode(item) {
      let regionNo = this.$route.params.regionNo || localStorage.getItem('regionNo');
      this.post(this.apis.getCoupon, {
        regionNo: regionNo,
        num: this.$route.params.num,
        orderDetailId: item.orderDetailId,
        memberId: this.couponInfo.memberId,
        productCatalogId: item.productCatalogId,
        phone: this.loginInfo.mobile
      }).then((res) => {
        if (res.data.code === '0') {
          this.$toast({
            message: '兑换成功',
            duration: 1000
          });



          const firstCoupon = this.dataList.find(coupon =>
              coupon.orderDetailId === item.orderDetailId
          );

          this.dataList = this.dataList.map(coupon => {
            if (coupon.orderDetailId === item.orderDetailId) {
              return {
                ...coupon,
                cardUseStatus: '1',
                isClickable: false,  // 不可点
                disabled: true      // 走禁用样式
              };
            }
            return coupon;
          });

          if (firstCoupon) {
            const firstCouponDate = new Date(firstCoupon.cardStartTime);
            const nextWeek = new Date(firstCouponDate.getTime() + 7 * 24 * 60 * 60 * 1000);
            const formattedDate = `${nextWeek.getFullYear()}-${(nextWeek.getMonth() + 1).toString().padStart(2, '0')}-${nextWeek.getDate().toString().padStart(2, '0')}`;

            this.dataList = this.dataList.map(coupon => {
              if (
                  coupon.goodsId === item.goodsId &&
                  !coupon.enabledStatus &&
                  coupon.cardUseStatus === '0'
              ) {
                return {
                  ...coupon,
                  cardStartTime: formattedDate,
                };
              }
              return coupon;
            });


          }
        }else {
          this.$toast({message: res.data.message || "激活失败", duration: 1500})
        }
      }).catch((error) => {
        handleRequestError(this, error);
      });
    }
  }
}
</script>
<style scoped lang="less">
.home_layout {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}

.home_body {
  width: 100%;
  height: 100%;
  padding-top: 26px;

  .coupon-item {
    padding: 0 24px;
    margin-bottom: 16px;

    .coupon-content {
      background: #fff;
      border-radius: 16px;
      display: flex;

      .left {
        display: flex;
        flex: 1;
        padding-right: 28px;
        border-right: 1px dashed #d3d3d3;
        padding: 20px 20px 20px 28px;

        .coupon-info {
          margin-left: 24px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .coupon-title {
            font-size: 26px;
            color: #3f2a20;
            line-height: 38px;
            font-weight: bold;
          }

          .coupon-count {
            font-size: 22px;
            color: #dd5701;
            line-height: 33px;
            margin-top: 10px;
          }

          .coupon-validate {
            font-size: 20px;
            color: #919191;
            line-height: 28px;

            &:first-child {
              margin-bottom: 12px;
            }
          }
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 20px 28px 20px 28px;

        .coupon-amount {
          color: #dd5701;
          font-size: 30px;
          display: flex;
          align-items: center;
          flex: 1;

          .amount {
            display: flex;
            align-items: end;
          }

          span {
            font-size: 60px;
            margin-right: 6px;
            font-weight: bold;
            line-height: 1;
          }
        }

        .btn {
          width: 170px;
          height: 56px;
          line-height: 56px;
          border-radius: 32px;
          background: #fb7019;
          color: #fff;
          font-size: 28px;
          text-align: center;
          cursor: pointer;
        }

        .expired-btn {
          background: rgba(251, 112, 25, 0.1);
          color: #dd5701;
          cursor: not-allowed;
        }
      }

      .pic {
        width: 176px;
        height: 176px;
        border-radius: 16px;
        display: block;
      }
    }
  }

  &_middle {
    &_nodata {
      display: grid;
      justify-content: center;
      align-items: center;
      padding-top: 30%;

      &_img {
        max-width: 200px;
        margin: 0 auto;
      }

      &_title {
        color: #3f3f3f;
        font-size: 30px;
        text-align: center;
        margin-top: 24px;
        font-weight: 400;
      }

      &_content {
        color: #848484;
        font-size: 20px;
        text-align: center;
        margin-top: 16px;
      }
    }
  }
}

/* 充值弹窗样式 */
.recharge-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  .recharge-modal-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .recharge-modal-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 500px;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);

    .recharge-modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
      border-bottom: 1px solid #eee;

      h3 {
        margin: 0;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }

      .recharge-modal-close {
        font-size: 24px;
        color: #999;
        cursor: pointer;
        line-height: 1;

        &:hover {
          color: #666;
        }
      }
    }

    .recharge-modal-body {
      padding: 24px;

      .recharge-confirm-text {
        font-size: 16px;
        color: #333;
        text-align: center;
        margin-bottom: 20px;

        .recharge-amount {
          color: #fb7019;
          font-weight: bold;
          font-size: 18px;
        }
      }

      .recharge-info {
        background: #f9f9f9;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 20px;

        p {
          margin: 8px 0;
          font-size: 14px;
          color: #666;

          span {
            color: #333;
            font-weight: 500;
          }

          .recharge-account {
            color: #cd0c09;
            font-weight: bold;
          }
        }
      }

      &.result-body {
        text-align: center;

        .result-icon {
          width: 60px;
          height: 60px;
          line-height: 60px;
          border-radius: 50%;
          margin: 0 auto 15px;
          font-size: 30px;

          &.success {
            background: #e8f5e9;
            color: #4caf50;
          }

          &.error {
            background: #ffebee;
            color: #f44336;
          }
        }

        .result-message {
          font-size: 16px;
          color: #666;
          margin-bottom: 10px;
        }
      }
    }

    .recharge-modal-footer {
      display: flex;
      padding: 0 24px 24px;

      button {
        flex: 1;
        height: 44px;
        border: none;
        border-radius: 22px;
        font-size: 16px;
        cursor: pointer;
        margin: 0 5px;

        &:focus {
          outline: none;
        }
      }

      .recharge-btn-cancel {
        background: #f0f0f0;
        color: #666;

        &:hover {
          background: #e0e0e0;
        }
      }

      .recharge-btn-confirm {
        background: #fb7019;
        color: #fff;

        &:hover {
          background: #e86416;
        }
      }
    }
  }
}
</style>